var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"age-chart"}},[(_vm.isMounted)?_c('vue-apex-charts',{attrs:{"type":"bar","height":"194","options":_vm.chartOptions,"series":_vm.series}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }